import React from "react";
import { ClearAllProps } from "@usereactify/search";

export type FilterClearAllProps = React.ComponentProps<
  NonNullable<ClearAllProps["render"]>
>;

export const FilterClearAll: React.FC<FilterClearAllProps> = (props) => {
  return <a onClick={props.clearAll}>{"Clear All"}</a>;
};
